module.exports = __webpack_public_path__ + "static/media/img-about-profile-president.b71bd656.jpg";